import api from '../../services/api';
import { useMutation } from "@tanstack/react-query";

export const useUploadFile = () => {

    const uploadFile = async ({ imageURL, name, location='' }) => {
        try {
            const blob = await fetch(imageURL).then((response) =>
                response.blob()
            );

            const originalFileName = name.replace(/^.*[\\\/]/, '');
            const timestamp = Date.now();
            const imageName = `${timestamp}_${originalFileName}`;

            const formData = new FormData();
            formData.append("image", blob, imageName);

            const { data } = await api.post(`${process.env.REACT_APP_API_URL}/upload/?location=${location}`, formData)
            return data;
        }
        catch (error) {
            throw new Error(error.response.data.message);
        }
    };
    return useMutation(uploadFile, {
        onSuccess: (data) => {
        },
        onError: (error) => {
            console.error("Error uploading image", error);
        },
    })
};
